import {
  Receipt,
  Wallet,
  Warehouse,
  BellRing,
  BarChart3,
  Users,
  CheckCircle2,
} from 'lucide-react'

export default function UseCasesSection() {
  const cases = [
    {
      icon: Receipt,
      title: 'Facturer rapidement',
      desc: 'Créez vos factures en quelques clics et gardez un historique propre de vos ventes.',
      bullets: [
        'Factures claires et organisées',
        'Suivi des ventes au quotidien',
        'Moins d’oubli et moins d’erreurs',
      ],
    },
    {
      icon: Wallet,
      title: 'Suivre les paiements',
      desc: 'Voyez immédiatement ce qui est payé, partiellement payé ou encore en attente.',
      bullets: [
        'Paiements complets ou partiels',
        'Vision claire des dettes clients',
        'Meilleur suivi des encaissements',
      ],
    },
    {
      icon: Warehouse,
      title: 'Gérer le stock',
      desc: 'Contrôlez vos entrées, sorties et quantités disponibles sans gérer tout sur papier.',
      bullets: [
        'Stock par dépôt et conteneur',
        'Inventaire plus fiable',
        'Historique des mouvements',
      ],
    },
    {
      icon: BellRing,
      title: 'Relancer les clients',
      desc: 'Envoyez des rappels aux clients qui n’ont pas encore réglé leurs factures.',
      bullets: [
        'Relances manuelles ou automatiques',
        'Moins d’oubli côté client',
        'Meilleure récupération des paiements',
      ],
    },
    {
      icon: BarChart3,
      title: 'Piloter votre activité',
      desc: 'Consultez vos ventes, dépenses et principaux indicateurs sans attendre la fin du mois.',
      bullets: [
        'Vue simple des performances',
        'Suivi des dépenses',
        'Décisions plus rapides',
      ],
    },
    {
      icon: Users,
      title: 'Mieux suivre vos clients',
      desc: 'Centralisez les coordonnées et l’historique de chaque client au même endroit.',
      bullets: [
        'Fiches clients organisées',
        'Compte client détaillé',
        'Base propre pour facturer et relancer',
      ],
    },
  ]

  return (
    <section className='border-t bg-muted/20'>
      <div className='mx-auto max-w-7xl px-4 py-20'>
        <div className='text-center max-w-3xl mx-auto'>
          <h2 className='text-3xl font-bold tracking-tight'>
            Ce que vous pouvez faire avec MOGESAPP
          </h2>
          <p className='text-muted-foreground mt-2'>
            MOGESAPP vous aide à mieux organiser votre commerce, suivre vos
            ventes, contrôler votre stock et récupérer plus facilement vos
            paiements.
          </p>
        </div>

        <div className='mt-12 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6'>
          {cases.map((item) => {
            const Icon = item.icon

            return (
              <div
                key={item.title}
                className='rounded-2xl border bg-background p-6 shadow-sm hover:shadow-md transition'
              >
                <div className='flex items-center gap-3'>
                  <div className='rounded-xl bg-primary/10 p-3'>
                    <Icon className='h-5 w-5 text-primary' />
                  </div>
                  <h3 className='text-lg font-semibold'>{item.title}</h3>
                </div>

                <p className='mt-4 text-sm text-muted-foreground'>
                  {item.desc}
                </p>

                <ul className='mt-5 space-y-2'>
                  {item.bullets.map((bullet) => (
                    <li
                      key={bullet}
                      className='flex items-start gap-2 text-sm text-muted-foreground'
                    >
                      <CheckCircle2 className='mt-0.5 h-4 w-4 text-primary shrink-0' />
                      <span>{bullet}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )
          })}
        </div>

        <div className='mt-12 rounded-2xl border bg-background p-6 max-w-4xl mx-auto'>
          <h3 className='text-lg font-semibold'>
            Ce que vous gagnez concrètement
          </h3>
          <div className='mt-4 grid gap-4 sm:grid-cols-2'>
            <div className='rounded-xl border p-4'>
              <div className='font-medium'>Moins de désordre</div>
              <p className='text-sm text-muted-foreground mt-1'>
                Toutes vos informations sont centralisées au même endroit.
              </p>
            </div>

            <div className='rounded-xl border p-4'>
              <div className='font-medium'>Moins de pertes</div>
              <p className='text-sm text-muted-foreground mt-1'>
                Vous voyez mieux le stock, les ventes et les paiements en
                attente.
              </p>
            </div>

            <div className='rounded-xl border p-4'>
              <div className='font-medium'>Plus de rapidité</div>
              <p className='text-sm text-muted-foreground mt-1'>
                Les tâches répétitives prennent moins de temps au quotidien.
              </p>
            </div>

            <div className='rounded-xl border p-4'>
              <div className='font-medium'>Plus de contrôle</div>
              <p className='text-sm text-muted-foreground mt-1'>
                Vous savez ce qui se passe réellement dans votre activité.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
